import React from 'react';
import TableBody from '@mui/material/TableBody';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { useMediaTableContext } from '@src/hooks';
import VpMediaTableBodyRow from '@vp-ui/widgets/VpMediaTable/VpMediaTableBodyRow';
import VpMediaSubmissionDetailsDialog from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaSubmissionDetailsDialog';

export const VpMediaTableBody = ({ data, history }) => {
  const { setSelectedSubmissionId, selectedSubmissionId, setPendingMediaId } = useMediaTableContext();

  const handleClose = () => {
    setSelectedSubmissionId(null);
    setPendingMediaId(null);
    history.push({
      pathname: '/media',
      search: history.location.search,
    });
  };

  return (
    <>
      <TableBody>
        {data?.data?.map((submission) => (
          <VpMediaTableBodyRow key={submission?.campaignSubmissionId} submission={submission} />
        ))}
      </TableBody>
      <VpMediaSubmissionDetailsDialog
        open={!!selectedSubmissionId}
        onClose={handleClose}
      />
    </>
  );
};

VpMediaTableBody.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
};

export default withRouter(VpMediaTableBody);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTableBody.jsx